export default "__VITE_ASSET__ChvWQJuC__"